import { settings } from '@/api/config';
import axios from 'axios';
import { getInitData } from '@/utils/getInitData';

export const getAllEarn = async () => {
  const tg = window?.Telegram?.WebApp;
  if (!tg?.initData) {
    throw new Error('Telegram WebApp не инициализирован');
  }
  const encodedInitData = encodeURIComponent(getInitData());

  try {
    const response = await axios.get(
      `${settings.url}api/users/earn/all?initData=${encodedInitData}`,
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении баланса:', error);
    throw error;
  }
};
